import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MatiImage from './../../assets/Mati.png';
import { Link as ScrollLink } from 'react-scroll';
import './HGS.css';

const HGS = () => {
    
    const [inviteClicked, setInviteClicked] = useState(false);

    function toggleInviteClicked() {
        setInviteClicked(true);
    }

    return (
        <article className="hgs">
            <Link className="back-button" to="/">Back</Link>

            <ScrollLink to = "message" spy={true} smooth={true} duration={500} delay={200}>
                <div className="landing">
                    <h1>HOT GREEK SUMMER</h1>
                    <h2>The movement, the <i>renaissance.</i></h2> 

                    <img src={MatiImage} alt="Mati" />

                    <button onClick={toggleInviteClicked}>An invitation, for you!</button>
                    
                </div>
            </ScrollLink>
            

            <div className={inviteClicked ? "message" : ""} id="message">
            {inviteClicked && 
                <>
                    <p>Hello True Believers,</p>
                    <p>To honour the hottest Greek summer to date, the City of Toronto has brought back Taste of the Danforth after a 2-year hiatus. Our movement will be making an appearance on the evening of August 8th, and your attendance would be greatly cherished. You know who to contact.</p>
                    <p>As always, I hope you have a scorchingly Hot Greek Summer.</p>
                    <p>Hot Regards,<br></br>Sean</p>
                </>
            }
            </div>

        </article>
    );
    
}

export default HGS;